import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AirCompressorsTopHead from './air-compressors-top-head';
import AirCompressorsContent from './air-compressors-content';
import AirCompressorsModals from './air-compressors-modals';
import { actions as airCompressorsActions, fetchAirCompressorsWithFilters } from './store/slice';

const { resetFilters } = airCompressorsActions;

const AirCompressorsView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAirCompressorsWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Air Compressors</h4>
              </div>
            </div>
            <AirCompressorsTopHead />
          </div>
          <AirCompressorsContent />
          <AirCompressorsModals />
        </div>
      </div>
    </div>
  );
};

export default AirCompressorsView;
